export default __webpack_public_path__ + "static/media/button_align_justify.69be6da7.svg";